// tienda/StatsStrip.jsx
// Proof metrics directly under the hero.

import React from "react";
import { motion } from "framer-motion";
import { BarChart3, Clock3, HandCoins, MapPinned } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";

const STATS = [
  { value: "S/ 8.90", label: "desde por entrega", icon: <HandCoins className="size-4" />, color: brand.primary },
  { value: "2 PM", label: "corte para almacén FM", icon: <Clock3 className="size-4" />, color: brand.accentGold },
  { value: "95%", label: "entregas a tiempo", icon: <BarChart3 className="size-4" />, color: brand.accentGreen },
  { value: "Perú", label: "cobertura con Olva y Shalom", icon: <MapPinned className="size-4" />, color: brand.plum },
];

export function StatsStrip() {
  return (
    <section className="border-b bg-white" style={{ borderColor: brand.line }}>
      <div className="mx-auto max-w-7xl px-4 py-5">
        <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
          {STATS.map(stat => (
            <motion.div
              key={stat.label}
              {...fadeUp}
              className="group flex items-center gap-3 rounded-2xl border bg-white p-4 shadow-sm transition-transform hover:-translate-y-0.5"
              style={{ borderColor: brand.line }}
            >
              <span className="grid size-10 shrink-0 place-items-center rounded-xl" style={{ background: `${stat.color}14`, color: stat.color }}>
                {stat.icon}
              </span>
              <div>
                <div className="text-2xl font-black leading-none" style={{ color: brand.ink }}>{stat.value}</div>
                <div className="mt-1 text-xs font-medium" style={{ color: brand.muted }}>{stat.label}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
